var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.915 17.042.456-2.897h-2.809v-1.883c0-.792.392-1.566 1.646-1.566h1.295V8.229a15.697 15.697 0 0 0-2.28-.195c-2.311 0-3.82 1.39-3.82 3.902v2.209H11.84v2.897h2.563v7.006h3.16v-7.006h2.352Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;